module.exports = __webpack_public_path__ + "img/1x.4606ea3.jpg";